import script from "./CatalogSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogSingle.vue?vue&type=script&setup=true&lang=js"

import "./CatalogSingle.vue?vue&type=style&index=0&id=626c7ce4&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626c7ce4"]])

export default __exports__